import React from 'react';
import Select from 'react-select';
import {Button } from './layout'
import './EditPage.css';
const cx = require('classnames');
const Checkbox = require('./Checkbox').default;


export class EditPageSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            value: props.value, 
            options: [],
            isLoading: false,
            inputValue: ''
        };
        this.debounceTimer = null;
    }

    componentDidMount() {
        this.updateOptions();
        this.updateValue();
    }

    handleChange(value) {
        this.setState({ value: value });
        if (this.props.onChange) {
            if (value === null) {
                // Handle clear selection
                this.props.onChange(this.props.id, '');
            } else if (Array.isArray(value)) {
                this.props.onChange(this.props.id, value.map(v => v.value));
            } else {
                this.props.onChange(this.props.id, value.value);
            }
        }
    }

    handleInputChange = (inputValue) => {
        this.setState({ inputValue });
        
        // Clear existing timer
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        // If async loading is enabled and we have a search function
        if (this.props.async && this.props.loadOptions && inputValue.length >= 2) {
            this.setState({ isLoading: true });
            
            // Debounce the search
            this.debounceTimer = setTimeout(() => {
                this.props.loadOptions(inputValue).then(options => {
                    this.setState({ 
                        options: options || [],
                        isLoading: false 
                    });
                }).catch(() => {
                    this.setState({ isLoading: false });
                });
            }, 300);
        }
    }

    componentDidUpdate(prevProps) {
        if (String(this.props.value) !== String(prevProps.value)) {
            this.updateValue();
        }
        if (this.props.options !== prevProps.options && !this.props.async) {
            this.updateOptions();
        }
    }

    updateOptions() {
        var options = [];
        if (this.props.nullable) {
            options.push({value: '', label: '--'});
        }
        if (this.props.options != undefined) {
            Object.keys(this.props.options).map(function (i) {
                options.push({value: i, label: this.props.options[i]});
                if (String(i) === String(this.props.value)) {
                    this.setState({ value: {value: String(i), label: this.props.options[i]} });
                }
            }, this);
            this.setState({ options: options });
        }  
    }
   
    updateValue() {
        if (this.props.options != undefined) {
            Object.keys(this.props.options).map(function (i) {
                if (Array.isArray(this.props.value)) {
                    const values = [];
                    this.props.value.forEach(val => {
                        if (val.id == i) {
                            values.push({
                                value: String(i),
                                label: this.props.options[i]
                            });
                        }
                    });
                    if (values.length > 0) {
                        this.setState(prevState => ({
                            value: [...(Array.isArray(prevState.value) ? prevState.value : []), ...values]
                        }));
                    }
                } else if (i === this.props.value) {
                    this.setState({ value: {value: String(i), label: this.props.options[i]} });
                }
            }, this);
        } else {
        //    this.setState({ value: {value: '', label: '--'} });
        }
    }
    
    render() {
        const { block, error, addonLeft, inputGroupClassName, nullable } = this.props;
        var errormsg = ( error != undefined && error.fields != undefined && error.fields.indexOf(this.props.id) > -1) ? true : false;

        // use label itself as ID (sanitized)
        const label = this.props.label || '';
        const disabled = this.props.disabled || false;
        const id = this.props.id || 'id_select_'+label.replace(/[^A-Za-z0-9-_]/g, '');

        return (
            <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
                <label className={ cx( {'': !block}) } htmlFor={ id }>{ label }</label>
                <div className={ cx('', {'col-sm-10 input-group':!block})} style={{padding: '0px'}}>
                { addonLeft ? <span className="input-group-addon">{ addonLeft }</span> : null }
                   <Select
                        styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                        }}
                        name={ id }
                        options={ this.state.options }
                 //       selected={ this.state.value }
                        //     className="form-control"
                        id={ id }
                        isMulti={ this.props.isMulti }
                        placeholder={ this.props.placeholder }
                        value={ this.state.value }
                        onChange={ this.handleChange.bind(this) }
                        onInputChange={ this.handleInputChange }
                        isLoading={ this.state.isLoading }
                        isClearable={ this.props.async || this.props.nullable }
                        menuContainerStyle={{ zIndex: 5 }}
                        isDisabled = {disabled}
                    />
                </div>
            </div>
        );
    }
}

export class EditPageCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }
    componentDidUpdate(prevProps) {
        if (this.state.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }
    handleChange(e) {
        this.setState({ value: e }, () => {
            this.props.onChange(this.props.id, this.state.value);
        });
    }
    render() {
        const { block, error, inputGroupClassName } = this.props;
        var value = this.state.value;
        var errormsg = ( error !== undefined && error.fields !== undefined && error.fields.indexOf(this.props.id) > -1);
        // use label itself as ID (sanitized)
        const label = this.props.label || '';
        const disabled = this.props.disabled || false;
        const id = this.props.id || 'id_checkbox_'+label.replace(/[^A-Za-z0-9-_]/g, '');
        return (
            <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
                <label className={ cx( {'': !block}) } htmlFor={ id }>{ label }</label>
                <div className={ cx('checkbox col-sm-8 input-group', {'':!block})} style={{padding: '0px'}}>
                    <Checkbox
                        id={ id }
                        checked={ value }
                        onChange={ this.handleChange.bind(this) }
                        disabled = { disabled }
                    />
                </div>
            </div>
        );
    }
}

export class EditPageTextField extends React.Component {
    static displayName = 'EditPageTextField';

    handleChange(e) {
        this.props.onChange(this.props.id, e.target.value);
    }
    render() {
        const { error, block, inputGroupClassName } = this.props;

        var errormsg = ( error != undefined && error.fields != undefined && error.fields.indexOf(this.props.id) > -1) ? true : false;
        const label = this.props.label || '';
        const addonLeft = this.props.addonLeft || false;

        // use label itself as ID (sanitized)
        let { id } = this.props;
        if (!id && typeof label == 'string')
            id = 'id_textfield_'+label.replace(/[^A-Za-z0-9-_]/g, '');

        // convert undefined and null values to an empty string
        var value = this.props.value;
        if (typeof value != 'string' && typeof value != 'number')
            value = '';

        // Extract additional HTML5 input attributes
        const additionalProps = {};
        if (this.props.step !== undefined) additionalProps.step = this.props.step;
        if (this.props.min !== undefined) additionalProps.min = this.props.min;
        if (this.props.max !== undefined) additionalProps.max = this.props.max;

        return (
            <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
                { label ?
                    <label htmlFor={ id }>
                        { label }
                    </label> : null }

                <div className={cx(inputGroupClassName ? inputGroupClassName : "col-sm-10 input-group")} style={{padding: '0px'}}>
                    { addonLeft ? <span className="input-group-addon">{ addonLeft }</span> : null }
                    <input
                        className={ cx( this.props.className ?  this.props.className : 'form-control' )}
                        disabled={ this.props.disabled }
                        onChange={ this.handleChange.bind(this) }
                        placeholder={ this.props.placeholder }
                        type={ this.props.type || 'text' }
                        value={ value }
                        autoComplete={ this.props.autocomplete ? this.props.autocomplete : "" }
                        id={ id }
                        {...additionalProps}
                    />
                </div>
            </div>
        );
    }
}

export class EditPageTextArea extends React.Component {
    handleChange(e) {
        this.props.onChange(this.props.id, e.target.value);
    }
    render() {
        const { error, block, inputGroupClassName } = this.props;
        var errormsg = ( error !== undefined && error.fields !== undefined && error.fields.indexOf(this.props.id) > -1);

        const label = this.props.label || '';
        const addonLeft = this.props.addonLeft || false;
        const rows = this.props.rows || "20";

        // use label itself as ID (sanitized)
        let { id } = this.props;
        if (!id && typeof label == 'string')
            id = 'id_textfield_'+label.replace(/[^A-Za-z0-9-_]/g, '');

        // convert undefined and null values to an empty string
        var value = this.props.value;
        if (typeof value != 'string' && typeof value != 'number')
            value = '';

        return (
            <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
                { label ?
                    <label htmlFor={ id }>
                        { label }
                    </label> : null }

                <div className={cx(inputGroupClassName ? inputGroupClassName : "col-sm-10 input-group")} style={{padding: '0px'}}>
                    { addonLeft ? <span className="input-group-addon">{ addonLeft }</span> : null }
                    <textarea
                        className={ cx( this.props.className ?  this.props.className : 'form-control' )}
                        disabled={ this.props.disabled }
                        onChange={ this.handleChange.bind(this) }
                        placeholder={ this.props.placeholder }
                        type={ this.props.type || 'text' }
                        value={ value }
                        autoComplete={ this.props.autocomplete ? this.props.autocomplete : "" }
                        id={ id }
                        rows = { rows }
                    />
                </div>
            </div>
        );
    }
}

export class EditPageButton extends React.Component {
    handleClick() {
        if (this.props.handleClick) {
            this.props.handleClick();
        }
    }
    render() {
        const {icon, bsStyle, value, disabled, className} = this.props;
        
        // Use bsStyle if provided, otherwise try to derive from className
        let buttonStyle = bsStyle;
        if (!buttonStyle && className) {
            if (className.includes('btn-primary')) buttonStyle = 'primary';
            else if (className.includes('btn-success')) buttonStyle = 'success';
            else if (className.includes('btn-danger')) buttonStyle = 'danger';
            else if (className.includes('btn-warning')) buttonStyle = 'warning';
            else if (className.includes('btn-info')) buttonStyle = 'info';
            else buttonStyle = 'default';
        }
        
        return (
            <Button
                bsStyle={buttonStyle}
                value={value || this.props.label}
                icon={icon}
                onClick={this.handleClick.bind(this)}
                disabled={disabled}
            />
        )
    }
}

export class EditPageFooter extends React.Component {
    static displayName = 'EditPageFooter';
    render() {
        return (
            <div className="panel-footer" style={{ 
                padding: '15px', 
                backgroundColor: '#f8f9fa', 
                borderTop: '1px solid #dee2e6',
                textAlign: 'right',
                marginTop: '20px'
            }}>
                <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap'
                }}>
                    { this.props.children }
                </div>
            </div>
        )
    }
}


export class EditPagePanel extends React.Component {
    static displayName = 'EditPagePanel';
    render() {
        // Convert single child to array for consistent handling
        const children = Array.isArray(this.props.children) 
            ? this.props.children 
            : [this.props.children];

        return(
            <div className={ this.props.className || "col-lg-4 col-md-6 col-sm-12" }>
                {
                    children.map(function (child, i) {
                        if (!child) return null; // Skip null/undefined children
                        
                        // Only pass error prop to components that expect it
                        if (typeof child.type === 'string' || 
                            !child.type.displayName || 
                            !['EditPageTextField', 'EditPageSelect', 'EditPageCheckbox', 'EditPageTextArea'].includes(child.type.displayName)) {
                            return React.cloneElement(child, { key: i });
                        }
                        return React.cloneElement(child, { key: i, error: this.props.error });
                    }, this)
                }
            </div>
        )
    }
}

export class EditPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {error: false}
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleSave() {
        this.props.handleSave();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.error !== this.props.error) {
            this.setState({error: this.props.error}, () => this.handleError());
        }
    }
    componentDidMount() {
        this.setState({error: this.props.error}, () => this.handleError());
    }


    handleError() {
        if (this.state.error) {

            var error = this.state.error;
            if (error.msg != '') {
                var errstr = error.msg;

                errstr = (errstr == undefined) ? "Backend Error" : errstr ;
                errstr = errstr.replace(/%s/gi, "Highlighted Field");
                // FIXME:
                // toastr.options.timeOut = 5000;
                // toastr.options.positionClass = "toast-top-center";
                // toastr.options.closeButton = true;
                // toastr['error'](errstr);
            }

        }
    }
    render() {
        var error = this.state.error;
        return(
            <div className="row edit-page-container">
                <div className="col-md-12">
                    <div className="panel panel-primary">
                        {this.props.title && (
                            <div className="panel panel-heading edit-page-title">
                                {this.props.title}
                            </div>
                        )}
                        <div className="panel panel-body">
                        <form method="post" className="form-horizontal">
                            <div className="row">
                                {
                                    Array.isArray(this.props.children) ?
                                        this.props.children.map(function (child, i) {
                                            return ( child && child.type && child.type.displayName == 'EditPagePanel' &&  React.cloneElement(child, { key: i, error: error }))
                                        }, this)
                                    :
                                        (this.props.children && this.props.children.type && this.props.children.type.displayName == 'EditPagePanel' && React.cloneElement(this.props.children, { error: error }))
                                }
                            </div>
                        </form>
                    </div>
                    <div className="panel panel-footer">
                        {
                            Array.isArray(this.props.children) ?
                                this.props.children.map(function (child, i) {
                                    return ( child && child.type && child.type.displayName == 'EditPageFooter' &&  React.cloneElement(child, { key: i, error: error }))
                                }, this)
                            :
                                (this.props.children && this.props.children.type && this.props.children.type.displayName == 'EditPageFooter' && React.cloneElement(this.props.children, { error: error }))
                        }
                        {
                            !this.props.noDefaultButtons &&
                                <div>
                                    <Button bsStyle="cancel" value="Cancel" onClick={this.handleCancel.bind(this)}/>
                                    <Button bsStyle="save" value="Save" onClick={this.handleSave.bind(this)}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
            </div>
            
        )
    }
}

